<template>
    <div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Punti" text="Punti"></localized-text>
            </label>
            <input class="form-control" type="number" step="0.1" v-model="localValue.points" />
        </div>
        <bonus-payments v-model="localValue.bonusPayments"></bonus-payments>
    </div>

</template>

<script lang="ts">
import * as OM from '@/model';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';
import bonusPayments from './bonusPayments.vue';

@Options({
    components: {
        bonusPayments
    }
})
export default class rewardConfig extends mixins(WithModel) {

    declare localValue: OM.RewardConfig;
}

</script>
